import { subDays, format } from "date-fns";
import { supabase } from "@/lib/supabase";
import { 
  BRANDS_SCORE_DAILY_TABLE_NAME, 
  BRANDS_PROMPTS_SCORE_DAILY_TABLE_NAME,
  BRANDS_MODELS_SCORE_DAILY_TABLE_NAME
} from "@/store/const";
import { throwOnSupabaseError } from "@/utils/errors";
import { transformSupabaseDates } from "@/utils/transformers";



export type BrandScoreEveryDayFetchArgs = {
    userID: string;
    days: number;
  };

export type BrandScoreByPromptFetchArgs = {
    userID: string;
    brandId: number;
    days: number;
};

export type BrandScoreByModelFetchArgs = {
    userID: string;
    brandId: number;
    days: number;
};


export const scoresApi = {
    fetchBrandScoreDays: async (args: BrandScoreEveryDayFetchArgs) => {
        const days = Math.max(1, Math.floor(args.days));
        const end = new Date();
        const start = subDays(end, days - 1);
        const startStr = format(start, "yyyy-MM-dd");
        const endStr = format(end, "yyyy-MM-dd");

        const { data, error } = await supabase
            .from(BRANDS_SCORE_DAILY_TABLE_NAME)
            .select("*")
            .eq("user_id", args.userID)
            .gte("date", startStr)
            .lte("date", endStr)
            .order("date", { ascending: true });
    
        throwOnSupabaseError(error);
        
        return transformSupabaseDates(data);
      },
    fetchBrandScoreByPromptDays: async (args: BrandScoreByPromptFetchArgs) => {
        const days = Math.max(1, Math.floor(args.days));
        const end = new Date();
        const start = subDays(end, days - 1);
        const startStr = format(start, "yyyy-MM-dd");
        const endStr = format(end, "yyyy-MM-dd");

        const { data, error } = await supabase
            .from(BRANDS_PROMPTS_SCORE_DAILY_TABLE_NAME)
            .select("*")
            .eq("user_id", args.userID)
            .eq("brand_id", args.brandId)
            .gte("date", startStr)
            .lte("date", endStr)
            .order("date", { ascending: true });

          throwOnSupabaseError(error);
          return transformSupabaseDates(data);
    },
    fetchBrandScoreByModelDays: async (args: BrandScoreByModelFetchArgs) => {
        const days = Math.max(1, Math.floor(args.days));
        const end = new Date();
        const start = subDays(end, days - 1);
        const startStr = format(start, "yyyy-MM-dd");
        const endStr = format(end, "yyyy-MM-dd");

        const { data, error } = await supabase
            .from(BRANDS_MODELS_SCORE_DAILY_TABLE_NAME)
            .select("*")
            .eq("user_id", args.userID)
            .eq("brand_id", args.brandId)
            .gte("date", startStr)
            .lte("date", endStr)
            .order("date", { ascending: true });

        throwOnSupabaseError(error);
        return transformSupabaseDates(data);
    },
}